export const dataTypes = {
  decimal: 'decimal',
  text: 'text',
  int: 'int'
}
